export const PAYER_TYPES = [

  {
    value: "person",
    label: "Persona"
  },

  {
    value: "hotel",
    label: "Hotel"
  },

  {
    value: "government",
    label: "Gobierno"
  },

  {
    value: "travel_agency",
    label: "Agencia de viajes"
  },

  {
    value: "tour_operator",
    label: "Operador turístico"
  },

  {
    value: "corporate",
    label: "Empresa corporativa"
  },

  {
    value: "other",
    label: "Otro"
  }

];